// extracted by mini-css-extract-plugin
module.exports = {"type":"type_type__wDWS8","size--small":"type_size--small__2TC06","size--xs":"type_size--xs__1BYKt"};